import type {
  CreatePurchaseOrderRequest,
  PurchaseOrderResponse,
  UpdatePurchaseOrderRequest,
} from "@stocks/shared";

export interface OrderLineFormValues {
  productId: string;
  optionId: string;
  /** 입력 중에는 문자열 */
  quantity: string;
}

export interface OrderFormValues {
  customerId: string;
  dueDate: string;
  memo: string;
  lines: OrderLineFormValues[];
}

export const EMPTY_ORDER_LINE: OrderLineFormValues = {
  productId: "",
  optionId: "",
  quantity: "1",
};

export const EMPTY_ORDER_FORM: OrderFormValues = {
  customerId: "",
  dueDate: "",
  memo: "",
  lines: [EMPTY_ORDER_LINE],
};

const toLines = (lines: OrderLineFormValues[]) =>
  lines.map((l) => ({
    productId: l.productId,
    optionId: l.optionId,
    quantity: Number(l.quantity),
  }));

export const toCreateOrderRequest = (
  v: OrderFormValues,
): CreatePurchaseOrderRequest => ({
  customerId: v.customerId,
  dueDate: v.dueDate,
  memo: v.memo.trim() || undefined,
  lines: toLines(v.lines),
});

export const toUpdateOrderRequest = (
  v: OrderFormValues,
): UpdatePurchaseOrderRequest => ({
  dueDate: v.dueDate,
  memo: v.memo.trim(),
  lines: toLines(v.lines),
});

export const toOrderFormValues = (o: PurchaseOrderResponse): OrderFormValues => ({
  customerId: o.customerId,
  dueDate: o.dueDate.slice(0, 10),
  memo: o.memo ?? "",
  lines: o.lines.map((l) => ({
    productId: l.productId,
    optionId: l.optionId,
    quantity: String(l.quantity),
  })),
});
